import createComponent from '@carvana/merch-components/createComponent';

export const ShaqbotSectionContainer = createComponent('section', {
  className:
    'mx-auto flex max-w-[740px] flex-col items-center justify-center gap-2xl self-stretch px-2xl pt-3xl sm:px-3xl sm:pt-4xl md:pt-6xl'
});

export const ShaqbotAvatar = createComponent('img', {
  className: 'h-[90px]'
});

export const ShaqbotHeading = createComponent('h2', {
  className: 'px-2xl text-center text-white t-heading-2xl md:t-heading-3xl'
});
